<template>
  <div class="login_container">
    <header>
      <div class="logo">基础医学院</div>
      <h1></h1>
    </header>
    <div class="main">
      <div class="login_box">
        <p>账号登录</p>
        <el-form class="login_form" ref="formInline" :model="formInline" :rules="ruleInline">
          <el-form-item prop="username">
            <el-input type="text" size="large" prefix-icon="el-icon-user" v-model="formInline.username" placeholder="请输入用户名" @keyup.enter.native="handleSubmit('formInline')"> </el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input type="password" size="large" v-model="formInline.password" prefix-icon="el-icon-lock" placeholder="请输入密码" @keyup.enter.native="handleSubmit('formInline')"> </el-input>
          </el-form-item>
          <el-form-item>
            <el-button class="login_btn" type="primary" :loading="loading" @keyup.enter.native="handleSubmit('formInline')" @click="handleSubmit('formInline')"> <span class="login-text">登录</span></el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <footer>
      基础医学院 版权所有©Copyrighy 2019-2020© 豫ICP备090363438号-3
      <span style="padding-left:10px">
        技术支持：河南恒茂创远科技股份有限公司
      </span>
    </footer>
  </div>
</template>
<script>
import Api from '../../api/index'
export default {
  data() {
    return {
      formInline: {
        username: '',
        password: ''
      },
      loading: false,
      ruleInline: {
        username: [{ required: true, message: '请确认账户', trigger: 'blur' }],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          {
            type: 'string',
            min: 6,
            message: '密码长度最少6个字符',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {
    handleSubmit(name) {
      this.$refs[name].validate(async valid => {
        if (valid) {
          this.loading = true
          const login = await Api.login.login(this.formInline)
          this.loading = false
          if (!login.success) {
            this.$message.error(login.msg)
          } else {
            if (login.rows.usertype != 5 && login.rows.usertype != 6) {
              window.localStorage.setItem('token', login.rows.accesstoken)
              this.$router.push('/home')
            } else {
              this.$message.info('暂无权限登录!')
            }
          }
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.login_container {
  width: 100%;
  height: 100%;
  header {
    display: flex;
    align-items: center;
    height: 70px;
    line-height: 70px;
    background-color: #fff;
    padding-left: 153px;
    h1 {
      font-size: 30px;
      color: #0670b8;
    }
    .logo {
      overflow: hidden;
      text-indent: -1000px;
      margin-right: 10px;
      width: 690px;
      height: 54px;
      background: url(~@/assets/img/logo.png) no-repeat center;
    }
  }
  footer {
    text-align: center;
    height: 66px;
    line-height: 66px;
  }
}
.main {
  position: relative;
  height: 800px;
  background: url(~@/assets/img/login_bg.png) no-repeat center;
  img {
    width: 100%;
    height: 100%;
  }
  .login_zz {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 62%;
    height: 100%;
    span {
      position: absolute;
      top: 42%;
      left: 33%;
      color: #fff;
      font-size: 91px;
    }
  }
}
.login_box {
  width: 628px;
  height: 564px;
  padding: 50px;
  padding-right: 30px;
  padding-top: 100px;
  box-sizing: border-box;
  background: url(~@/assets/img/logoin.png) left top no-repeat;
  position: absolute;
  top: 50%;
  left: 80%;
  transform: translate(-50%, -50%);
  p {
    padding: 20px 40px;
    margin-bottom: 20px;
    font-size: 30px;
    font-weight: 400;
    text-align: center;
    color: #fff;
  }
}
.login_form {
  width: 100%;
  padding: 0 80px;
  box-sizing: border-box;
  text-align: center;
  .login_btn {
    margin-top: 10px;
    width: 100%;
    height: 40px;
    font-size: 18px;
    border-radius: 6px;
    border: none;
    background-color: #20c1ff;
  }
  .login-text {
    letter-spacing: 0.5em;
  }
  /deep/.el-input__inner {
    background: transparent;
    border: 1px solid #5fcac4;
    color: #fff;
  }
  /deep/ .el-form-item__error {
    color: #ffff00;
  }
  /deep/.el-form-item.is-error .el-input__inner,
  .el-form-item.is-error .el-input__inner:focus,
  .el-form-item.is-error .el-textarea__inner,
  .el-form-item.is-error .el-textarea__inner:focus,
  .el-message-box__input input.invalid,
  .el-message-box__input input.invalid:focus {
    border-color: #ffff00;
  }
}
</style>
